import React, { useState } from 'react';
import { validateFiles } from '@askporter/utils/src/utils/fileUploader/validateFiles';
import { List, Theme, useMediaQuery, Box } from '@mui/material';
import { FilePath } from '@askporter/client-grieg-lyric';
import { AllAllowedUploaderFileTypes } from '@askporter/utils';
import { DragAndDropUploaderBox } from '../components/DragAndDropUploaderBox';
import { FilePreview } from '../components/FilePreview';
import { UploaderFileItem } from '../components/UploaderFileItem';
import { FileUploaderProps } from '../types';

export const FileUploader = ({
  idPrefix,
  required = false,
  t,
  value,
  hideFileList = false,
  helperText,
  accept = AllAllowedUploaderFileTypes,
  maxBytes,
  maxFiles,
  containerProps = {},
  deleteButtonVisible = true,
  uploaderDisabled = false,
  onValidFilesDrop,
  onInvalidFilesDrop,
  onDelete,
  deletionEnabled = true,
  requiredFileError = false,
  canPreview = true,
  hideStateLabel = false,
  showImageThumbnail = false,
}: FileUploaderProps): JSX.Element => {
  const isSmallDevice = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const [filePreview, setFilePreview] = useState<FilePath | undefined>();

  return (
    <Box {...containerProps}>
      <DragAndDropUploaderBox
        t={t}
        idPrefix={idPrefix}
        onDrop={async (files: File[]) => {
          const validatedFiles = await validateFiles({
            files,
            accept,
            maxSize: maxBytes,
            maxFiles,
            onInvalidFilesDrop,
            existingFilesCount: value.length,
          });
          if (validatedFiles.length > 0) {
            onValidFilesDrop(validatedFiles);
          }
        }}
        requiredFileError={requiredFileError}
        disabled={uploaderDisabled}
        required={required}
        helperText={helperText}
        accept={accept}
      />
      {!hideFileList && (
        <List>
          {value.map((file, _id) => (
            <UploaderFileItem
              file={{
                ...file,
                state: file.state || 'success',
                path: file.path || file.tempPath,
                handleRemove: () => {
                  onDelete(file);
                },
                setFilePreview: () => {
                  setFilePreview({
                    fileUrn: file.file.fileRef,
                    filePath: file.path || file.tempPath,
                  });
                },
              }}
              idPrefix={`${idPrefix}-uploader-list`}
              removeBtnDisabled={!deletionEnabled}
              t={t}
              key={_id}
              isRemoveFileBtnVisible={deleteButtonVisible}
              canPreview={canPreview}
              hideStateLabel={hideStateLabel}
              showImageThumbnail={showImageThumbnail}
            />
          ))}
        </List>
      )}

      {filePreview && (
        <FilePreview
          t={t}
          isSmallDevice={isSmallDevice}
          file={filePreview}
          handleClose={() => setFilePreview(undefined)}
        />
      )}
    </Box>
  );
};
